module.exports = __webpack_public_path__ + "img/9791157231294.de85d260.jpg";